import { ProfileService } from './../../core/services/profile/profile.service';
import { transformToNumber } from '@shared/utils/format-number';
import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'noDecimal'
})
export class NoDecimalPipe implements PipeTransform {

  constructor(private decimalPipe: DecimalPipe, private profile: ProfileService) { }
  /**
   * Formats the provided value using native Angular Pipe
   * @param value
   * @param fractionSize
   */
  transform(value: number | string, fractionSize?: number): string {
    const numberValue = transformToNumber(value, this.profile.getGroupingSymbol(), this.profile.getDecimalSymbol());
    return this.decimalPipe.transform(numberValue, "1.0-0", this.profile.getLocale());
  }
}
